import { MARQUEE_ITEMS } from "@/data/site";

const Marquee = () => {
  const row = (key) => (
    <div key={key} className="flex shrink-0 items-center">
      {MARQUEE_ITEMS.map((item, i) => (
        <span key={`${key}-${i}`} className="flex items-center">
          <span className="whitespace-nowrap px-10 font-serif text-2xl italic text-white/40 md:text-3xl">
            {item}
          </span>
          <span className="h-1.5 w-1.5 rounded-full bg-gold/60" />
        </span>
      ))}
    </div>
  );

  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-white/10 bg-black py-8"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee">
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
};

export default Marquee;
